import { Controller, useFormContext } from 'react-hook-form';
import { FormRow } from '@gravity-ui/components';
import { TextArea } from '@gravity-ui/uikit';

interface FormTextAreaProps {
	name: string;
	label: string;
	placeholder?: string;
	required?: boolean;
	className?: string;
	minRows?: number;
	maxLength?: number;
}

export const FormTextArea = ({
	name,
	label,
	placeholder,
	required = false,
	className,
	minRows = 4,
	maxLength = 2000,
}: FormTextAreaProps) => {
	const { control, watch } = useFormContext();
	const value = watch(name);

	return (
		<FormRow className={className} label={label} required={required}>
			<Controller
				control={control}
				name={name}
				render={({ field: { onChange, onBlur, ref }, fieldState: { error } }) => (
					<TextArea
						placeholder={placeholder || label}
						size="xl"
						minRows={minRows}
						hasClear
						error={error?.message}
						value={value || ''}
						note={<span>{(value?.length || 0)}/{maxLength}</span>}
						onChange={onChange}
						onBlur={onBlur}
						ref={ref}
					/>
				)}
			/>
		</FormRow>
	);
};
